import React from "react"
import celerIMSDKPng from "../../images/logo/celerIMSDK.png"
import cBridgeSDKPng from "../../images/logo/cBridgeSDK.png"
import stateGuardianNetworkPng from "../../images/logo/stateGuardianNetwork.png"
import celerCBridgePng from "../../images/logo/celerCBridge.png"
import layer2FinancePng from "../../images/logo/layer2Finance.png"
import twitterLogo from "../../images/logo/link-icon-1.png"
import telegramLogo from "../../images/logo/link-icon-2.png"
import forumLogo from "../../images/logo/link-icon-3.png"
import githubLogo from "../../images/logo/link-icon-4.png"
import discordLogo from "../../images/logo/link-icon-5.png"
import weixinLogo from "../../images/logo/link-icon-6.png"
import youtubeLogo from "../../images/footer/footer-youtube.png"
import coinmarketcapLogo from "../../images/logo/coinmarketcapWhite.svg"
import { globalLinks } from "../../constants"
import UseIsMobile from "../../hooks/UseIsMobile"

import "./footer.scss"

const products = [
  {
    title: "State Guardian Network",
    icon: stateGuardianNetworkPng,
    link: globalLinks.productLinks.sgn,
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    title: "Celer cBridge",
    icon: celerCBridgePng,
    link: globalLinks.productLinks.cbridge,
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    title: "layer2.finance",
    icon: layer2FinancePng,
    link: globalLinks.productLinks.layer2finance,
    rel: "noopener noreferrer",
    target: "_blank",
  },
]

const build = [
  {
    title: "cBridge SDK",
    icon: cBridgeSDKPng,
    link: globalLinks.buildLinks.cBridgeSDK,
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    title: "Celer IM SDK",
    icon: celerIMSDKPng,
    link: globalLinks.buildLinks.celerInterChainMessageSDK,
    rel: "noopener noreferrer",
    target: "_blank",
  },
]

const homeLink = {
  title: "Home",
  link: "/",
}

const otherLinks = [
  {
    title: "TECHNOLOGY",
    link: "/technology",
  },
  {
    title: "BLOG",
    link: "https://blog.celer.network/",
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    title: "COMMUNITY",
    link: "/community",
  },
  {
    title: "ABOUT",
    link: "/about",
  },
  {
    title: "CAREER",
    link: "/career",
  },
]

const otherIcons = [
  {
    icon: twitterLogo,
    link: globalLinks.iconLinks.twitter,
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    icon: telegramLogo,
    link: globalLinks.iconLinks.telegram,
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    icon: forumLogo,
    link: globalLinks.iconLinks.forum,
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    icon: githubLogo,
    link: globalLinks.iconLinks.github,
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    icon: discordLogo,
    link: globalLinks.iconLinks.discord,
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    icon: weixinLogo,
    link: globalLinks.iconLinks.weixin,
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    icon: youtubeLogo,
    link: globalLinks.iconLinks.youtube,
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {
    icon: coinmarketcapLogo,
    link: globalLinks.iconLinks.coinmarketcap,
    rel: "noopener noreferrer",
    target: "_blank",
  },
  {},
]

export default function Footer() {
  const [isMobile] = UseIsMobile()
  return (
    <div className="footer">
      <div className="footer-contents">
        {isMobile ? (
          <div
            key="mobile-home"
            className="footer-content"
            style={{ paddingBottom: 20 }}
          >
            <div className="footer-content-title">
              <a
                className="footer-content-link"
                href={homeLink.link}
                style={{ fontWeight: "bold" }}
              >
                <div className="footer-conten-title other-link">
                  {homeLink.title}
                </div>
              </a>
            </div>
          </div>
        ) : null}
        <div className="footer-content" key="footer-products">
          <div className="footer-content-title">PRODUCTS</div>
          <div className="footer-content-subtitles">
            {products.map(item => {
              return (
                <a
                  className="footer-content-subtitle footer-content-link"
                  href={item.link}
                  target={item.target}
                  rel={item.rel}
                >
                  <div className="subtitle-icon">
                    <img src={item.icon} alt="" />
                  </div>
                  <div className="subtitle-text">{item.title}</div>
                </a>
              )
            })}
          </div>
        </div>
        <div className="footer-content" key="footer-build">
          <div className="footer-content-title">BUILD</div>
          <div className="footer-content-subtitles">
            {build.map(item => {
              return (
                <a
                  className="footer-content-subtitle footer-content-link"
                  href={item.link}
                  target={item.target}
                  rel={item.rel}
                >
                  <div className="subtitle-icon">
                    <img src={item.icon} alt="" />
                  </div>
                  <div className="subtitle-text">{item.title}</div>
                </a>
              )
            })}
          </div>
        </div>
        <div className="footer-content" key="footer-otherLinks">
          <div className="footer-content-textlinks">
            {otherLinks.map(item => {
              return (
                <a
                  className="footer-content-link"
                  href={item.link}
                  target={item.target}
                  rel={item.rel}
                >
                  <div className="footer-conten-title other-link">
                    {item.title}
                  </div>
                </a>
              )
            })}
          </div>
        </div>
        <div className="footer-content other-icons" key="footer-otherIcons">
          {otherIcons.map(item => {
            return (
              <a
                className="footer-content-link"
                href={item.link}
                target={item.target}
                rel={item.rel}
              >
                <div className="icon">
                  <img src={item.icon} alt="" />
                </div>
              </a>
            )
          })}
        </div>
      </div>
      <div className="footer-subscribe"></div>
      <div className="footer-desc">
        <div className="footer-desc-block">
          <div>Contact: info@celer.network</div>
          <div>Privacy</div>
          <div>Terms</div>
        </div>
        <div className="footer-desc-block">
          <div>© Copyright 2018-{new Date().getFullYear()} Celer Network.</div>
          <div>All Rights Reserved</div>
        </div>
      </div>
    </div>
  )
}
